module.exports = __webpack_public_path__ + "img/9.0d0d220f.jpg";